import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { PUT_URL } from '@utils/api/endpoints.ts';

const upsertPreferenceByKey = (key: string, value: string) =>
  Axios.put(PUT_URL(key).userPreferenceByKey, { key, value }).then(
    res => res.data
  );

export const useUpsertUserPreference = () => {
  const queryClient = useQueryClient();

  return useMutation<
    unknown,
    AxiosError<BaseError>,
    { key: string; value: string }
  >(({ key, value }) => upsertPreferenceByKey(key, value), {
    onSuccess: () => {
      queryClient.invalidateQueries(['userPreferences']);
    },
    useErrorBoundary: false
  });
};
